module.exports = __webpack_public_path__ + "static/bakery-fe9f031035ecbf650ea89b8337188724.png";